<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10 ">
              <span class="span marginRight10 width80 textAlignRight"
                >网关ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >网关名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >分组/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建人 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.nickname"
                  placeholder="请输入创建人名称"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建人ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入创建人ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >创建时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >网关地址 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.macAddr"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10 marginRight10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
            <div class="flex align-items marginRight10 marginBottom10">
              <el-button
                type="danger"
                size="medium"
                @click="handleDeletes([...selectedRowKeys])"
                >删除</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="image" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.image"
          :preview-src-list="[row.image]"
        >
        </el-image>
      </template>
      <template slot="codeImage" slot-scope="{ row }">
        <el-image
          style="width: 80px; height: 80px"
          :src="row.codeImage"
          :preview-src-list="[row.codeImage]"
        >
        </el-image>
      </template>
      <template slot="userNum" slot-scope="{ row }">
        <div
          style="color: #00D8C3; cursor: pointer"
          @click="
            () => {
              memberDialogVisible = true;
              memberForm.id = row.id;
            }
          "
        >
          {{ row.userNum }}
        </div>
      </template>
      <template slot="deviceNum" slot-scope="{ row }">
        <div
          style="color: #00D8C3; cursor: pointer"
          @click="getJump('/device/manage', row, '设备列表')"
        >
          {{ row.deviceNum }}
        </div>
      </template>

      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleEdit(row)"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete([row])"
          style="color:  #ff001f!important"
          >删除</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleRecreateImage([row])"
          style="color: #46adf9 !important"
          >重新生成二维码</el-button
        >
      </template>
    </avue-crud>
    <el-drawer
      v-if="drawerVisible"
      title="修改网关"
      :visible.sync="drawerVisible"
      direction="rtl"
      :before-close="handleClose"
      custom-class="demo-drawer"
      :wrapperClosable="false"
    >
      <div class="demo-drawer__content">
        <avue-form ref="form" v-model="form" :option="formOption">
          <template slot="image">
            <FormImgUpload
              :url="form.image"
              @upload="upload"
              :limit="1"
              :maxSize="2"
              :accept="'.png,.jpg'"
              :multiple="true"
            />
          </template>
          <template slot="userId">
            <el-button v-if="!form.userId" @click="handleTable"
              >请选择</el-button
            >
            <el-button v-else @click="handleTable">{{
              form.userPhone
            }}</el-button>
          </template>
        </avue-form>
        <div class="demo-drawer__footer">
          <el-button @click="handleClose">取消</el-button>
          <el-button
            type="primary"
            :loading="showLoadingForm"
            @click="submit(form)"
            >确认</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      v-if="dialogVisible"
      :title="`${'选择用户'}`"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleDialogClose"
      :close-on-click-modal="false"
    >
      <UserRadioTable @selectUserId="selectUserId" :userId="form.userId" />
    </el-dialog>

    <!-- 查看成员 弹框 抽屉  -->
    <el-dialog
      v-if="memberDialogVisible"
      :title="`${'查看网关人员'}`"
      :visible.sync="memberDialogVisible"
      width="45%"
      :before-close="handleMemberDialogClose"
      :close-on-click-modal="false"
    >
      <GatewayTable :id="memberForm.id" />
    </el-dialog>
  </div>
</template>

<script>
import {
  gatewayList,
  gatewayDelete,
  gatewayDeletes,
  gatewayUpdate,
  gatewayUserList,
  gatewayRecreateCodeImage
} from "@/api/user/gateway";
import dayjs from "dayjs";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import UserRadioTable from "@/components/userRadioTable";
import GatewayTable from "./components/gatewayTable.vue";
export default {
  name: "index",
  components: {
    FormImgUpload,
    UserRadioTable,
    GatewayTable,
  },
  data() {
    return {
      searchData: {
        // title: "",
        // createTime: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "ID",
            prop: "gatewayId",
          },
          {
            label: "网关名称",
            prop: "name",
          },
          {
            label: "网关图片",
            prop: "image",
          },
          {
            label: "网关二维码",
            prop: "codeImage",
          },
          {
            label: "网关型号",
            prop: "foreignCommType",
          },
          {
            label: "网关地址",
            prop: "macAddr",
          },
          {
            label: "归属分组",
            prop: "groupName",
          },
          {
            label: "创建人",
            prop: "nickname",
          },
          {
            label: "创建人手机",
            prop: "phone",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "成员",
            prop: "userNum",
          },
          {
            label: "设备",
            prop: "deviceNum",
          },
        ],
      },

      drawerVisible: false,
      form: {
        id: "",
        userId: "",
        userPhone: "",
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "100",
        row: true,
        column: [
          {
            label: "网关图片",
            prop: "image",
            type: "text",
            maxlength: 50,
            span: 24,
          },
          {
            label: "网关名称",
            prop: "name",
            // type: "text",
            maxlength: 12,
            span: 16,
            row: true,
            placeholder: "请输入",
            rules: [
              {
                required: true,
                message: "请输入分组名称",
                trigger: "blur",
              },
            ],
          },
          {
            label: "创建人",
            prop: "userId",
            // type: "text",
            maxlength: 11,
            span: 16,
            row: true,
            placeholder: "请选择",
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      memberForm: {
        id: "",
      },
      memberDialogVisible: false,
      gatewayList: [], //网关列表
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      gatewayList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 添加
    handleCreate() {
      this.form = {
        image: [],
        id: "",
      };
      this.drawerVisible = true;
    },
    // 关闭
    handleClose() {
      this.drawerVisible = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //编辑
    async handleEdit(row) {
      console.log(row);
      this.form.id = row.id;
      this.drawerVisible = true;
      this.form = {
        id: row.id,
        image: row.image ? [row.image] : [],
        name: row.name,
        userId: row.createUserId,
        userPhone: row.phone,
      };
      console.log(this.form, "this.formthis.form");
    },

    // 删除
    handleDelete(row) {
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        gatewayDelete({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },
    // 批量删除
    handleDeletes(row) {
      if (!row.length) {
        this.$message.error("至少选择一个");
        return;
      }
      // console.log('删除',row)
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        gatewayDeletes({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },

    // 重新生成二维码
    handleRecreateImage(row) {
      if (!row.length) {
        this.$message.error("至少选择一个");
        return;
      }
      this.$confirm("确定重新生成吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        gatewayRecreateCodeImage({
          id: row.map((obj) => obj.id).join(","),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("重新生成成功!");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },

    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },

    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (form.name.length > 12 || form.name.length < 2) {
            this.$message.success("名称长度2-12");
            return;
          }
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          // return
          if (form.id) {
            gatewayUpdate({
              ...form,
              image: form.image && form.image.length > 0 ? form.image[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.drawerVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          } else {
            groupAdd({
              ...form,
              image: form.image && form.image.length > 0 ? form.image[0] : "",
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success("操作成功");
                  this.drawerVisible = false;
                  setTimeout(() => {
                    this.resetForm();
                  }, 500);
                  this.onLoad();
                  this.showLoadingForm = false;
                } else {
                  // this.$message.error(res.msg);
                  this.showLoadingForm = false;
                  done();
                }
              })
              .catch(() => (this.showLoadingForm = false));
          }
          // this.form.type = 1;
          // done()
        }
      });
    },
    //富文本框变化替换值
    editoChange(e) {
      this.form.details = e;
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.image = [...e];
      } else {
        this.form.image = [...this.form.image, e];
      }
    },

    //选择用户id打开弹窗
    handleTable() {
      this.dialogVisible = true;
    },
    //关闭用户选择弹框
    handleDialogClose() {
      this.dialogVisible = false;
    },
    //选择用户id
    selectUserId(e) {
      this.form.userId = e.id;
      this.form.userPhone = e.phone;
      this.dialogVisible = false;
    },

    handleMemberDialogClose() {
      this.memberDialogVisible = false;
    },
    //跳转页面列表
    getJump(url, row, name) {
      const indexof = this.$globalMethod(url);
      this.$root.eventHub.$emit("changeSubMenuIndex", String(indexof));
      // this.$store.commit("setSubMenuIndex", String(obj.indexof));
      if (url != this.$store.state.index.router) {
        this.$router.push({ path: url, query: { gatewayId: row.gatewayId } });
        let tableTabs = this.$store.state.index.tableTabs;
        let data = {
          title: name,
          name: "0",
          url: url,
          index: this.$store.state.index.SubMenuIndex,
        };
        let exist = false;
        tableTabs.forEach((item) => {
          if (item.title == data.title) {
            data.name = item.name;
            exist = true;
          }
        });
        if (!exist) {
          tableTabs.forEach((item, index) => {
            if (index + 1 == tableTabs.length) {
              data.name = (item.name * 1 + 1).toString();
            }
          });
        }
        this.$root.eventHub.$emit("changeTableTabs", { type: exist, data });
      }
    },
  },
};
</script>

<style scoped>
/deep/ .el-drawer {
  width: 40% !important;
}

.demo-drawer__content {
  padding: 0 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.demo-drawer__footer {
  border-top: 1px solid #ddd;
  padding: 10px 30px;
  display: flex;
  justify-content: right;
}
.content_top_right_user {
  width: 40px;
  height: 40px;
  margin-left: -20px;
  border-radius: 50%;
}
.content_top_right_user:first-of-type {
  margin-left: 0px;
}
</style>
